// Árbol de fallas (helpdesk_failure_categories), guardado igual en ambos catálogos:
//   nivel 1 = Origen · nivel 2 = Tipo · nivel 3 = Subtipo (opcional)
// Siniestro muestra el Origen: HUMANO → ACCIDENTAL → CULPOSO/DOLOSO, DESASTRE NATURAL → GEOLÓGICO...
// Incidente solo tiene Tipo → Subtipo: usa un origen fijo propio (INCIDENTE) que no se muestra.
// No puede compartir HUMANO: `code` es único en toda la tabla y en GLPI se mezclarían ambos árboles.
export const CATALOG_ORIGINS = {
  siniestro: [
    { code: 'HUMANO', name: 'HUMANO' },
    { code: 'DESASTRE_NATURAL', name: 'DESASTRE NATURAL' },
  ],
  incidente: [
    { code: 'INCIDENTE', name: 'INCIDENTE' },
  ],
}

// Origen preseleccionado al dar de alta un tipo en el catálogo (no aplica a tickets)
export const DEFAULT_ORIGIN_CODE = 'HUMANO'

export const originsFor = catalog => CATALOG_ORIGINS[catalog] || CATALOG_ORIGINS.incidente

export const showOrigin = catalog => originsFor(catalog).length > 1

// Las raíces pueden venir de GLPI con otro código: se compara por código o por nombre
export const isOrigin = (root, origin) => !!root && !!origin
  && (root.code === origin.code || String(root.name || '').toUpperCase() === origin.name)

export const isDefaultOrigin = root => !!root
  && (root.code === DEFAULT_ORIGIN_CODE || String(root.name || '').toUpperCase() === DEFAULT_ORIGIN_CODE)

